var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"route":_vm.$route}}),_c('PageRowWrapper',[_c('div',{staticClass:"col-sm-12"},[(_vm.model)?_c('ModelForm',{attrs:{"model":_vm.model}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }